import { ActionButton, ActionButtonType, Callout } from "@octopusdeploy/design-system-components";
import type { ProjectResource } from "@octopusdeploy/octopus-server-client";
import { HasGitPersistenceSettings, HasRunbooksInGit, HasVariablesInGit } from "@octopusdeploy/octopus-server-client";
import { links } from "@octopusdeploy/portal-routes";
import * as React from "react";
import { useState } from "react";
import { Action, useProjectScopedAnalyticActionDispatch } from "~/analytics/Analytics";
import { useProjectContext } from "~/areas/projects/context";
import CustomDialog from "~/components/Dialog/CustomDialog";
import { useSpaceAwareNavigation } from "~/components/Navigation/SpaceAwareNavigation/useSpaceAwareNavigation";
import { EnableProjectRunbooksDialog } from "./EnableProjectRunbooksDialog";
import MigrateProjectRunbooksWizard from "./MigrateProjectRunbooksDialog";
interface NewFeatureCalloutTitleProps {
    title: string;
}
const NewFeatureCalloutTitle: React.FC<NewFeatureCalloutTitleProps> = (props: NewFeatureCalloutTitleProps) => {
    return <>{props.title}</>;
};
NewFeatureCalloutTitle.displayName = "NewFeatureCalloutTitle"
interface MigrageProjectRunbooksToGitProps {
    project?: ProjectResource;
    hasNoRunbooks: boolean;
}
const MigrateProjectRunbooksBanner: React.FC<MigrageProjectRunbooksToGitProps> = (props: MigrageProjectRunbooksToGitProps) => {
    const [dialogOpen, setDialogOpen] = useState(false);
    const projectContext = useProjectContext();
    const project = projectContext.state.model;
    const dispatchAction = useProjectScopedAnalyticActionDispatch(projectContext.state.model.Id);
    const navigation = useSpaceAwareNavigation();
    // If this is a database project, or runbooks are already in Git, don't show the banner
    if (!HasGitPersistenceSettings(project.PersistenceSettings) || HasRunbooksInGit(project.PersistenceSettings)) {
        return null;
    }
    const openDialogWithAnalytics = () => {
        dispatchAction("Start Moving Runbooks to Git", { resource: "Runbooks", action: Action.Configure });
        setDialogOpen(true);
    };
    const navigateToVariablesPage = () => {
        const variablesUrl = links.projectVariablesPage.generateUrl({ spaceId: project.SpaceId, projectSlug: project.Slug });
        navigation.navigate(variablesUrl);
    };
    const hasVariablesInGit = HasVariablesInGit(project.PersistenceSettings);
    const calloutType = hasVariablesInGit ? "new-feature" : "information";
    return (<Callout type={calloutType} title={<NewFeatureCalloutTitle title="Store Runbooks in Git"/>}>
            {hasVariablesInGit ? (<>
                    <p>You can now store your Runbooks in a Git repository alongside your deployment process and variables.</p>
                    <ActionButton type={ActionButtonType.Secondary} label={props.hasNoRunbooks ? "Enable Config as Code Runbooks" : "Migrate Runbooks to Git"} onClick={() => openDialogWithAnalytics()}/>
                </>) : (<>
                    <p>Variables must be migrated to Git before Runbooks can be migrated.</p>
                    <ActionButton type={ActionButtonType.Secondary} label="Go to Variables Page" onClick={navigateToVariablesPage}/>
                </>)}
            {props.hasNoRunbooks ? (<EnableProjectRunbooksDialog open={dialogOpen} close={() => setDialogOpen(false)} project={project}/>) : (<CustomDialog open={dialogOpen} close={() => setDialogOpen(false)} render={(props) => <MigrateProjectRunbooksWizard {...props}/>}/>)}
        </Callout>);
};
MigrateProjectRunbooksBanner.displayName = "MigrateProjectRunbooksBanner"
export default MigrateProjectRunbooksBanner;
